export const socialData = [
   {
      link: 'https://www.linkedin.com/in/nilesh-lad-476216216/',
      icon: "fa-brands fa-linkedin",

   },
   {
      link: 'https://github.com/nileshlad09',
      icon:  "fa-brands fa-github",
   },
   {
      link: 'https://twitter.com/Nileshlad09',
      icon: "fa-brands fa-twitter",
   },
]